import { Block } from "@block";
import { QueueSpacing } from "@components/spacing";
import ScreenNameType from "@navigation/nav-screens";
import { StackActions, useNavigation } from "@react-navigation/core";
import images from "@styles/images";
import { spacing } from "@styles/spacing";
import Tippy from "@tippyjs/react";
import { actionLogout } from "app/modules/login/reducer/actions";
import auth from "app/shared/services/auth";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Image, Linking, TouchableOpacity, View } from "react-native";
import { Appbar, Divider, IconButton, Menu, Text, useTheme } from "react-native-paper";
import { useDispatch } from "react-redux";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import "tippy.js/dist/tippy.css";
import IconsYellowBanking from "../icons/icon-yellow-banking/IconsYellowBanking";
import { SideMenuContext } from "../side-menu/side-menu";

const HeaderNav = () => {
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();
  const { t } = useTranslation();
  const { colors, fonts } = useTheme();
  const [visible, setVisible] = React.useState(false);
  const sideMenu = React.useContext(SideMenuContext);
  const openMenu = React.useCallback(() => setVisible(true), []);
  const closeMenu = React.useCallback(() => setVisible(false), []);

  const handlerParamsAppFlyer = () => {
    console.log("handlerParamsAppFlyer");
    return {
      eventName: "af_hotline",
      params: {
        af_channel: "ib_rb",
        af_hotline: String(true),
      },
    };
  };

  const onPressLogout = React.useCallback(async () => {
    auth.logout();
    dispatchStore(actionLogout());
  }, [dispatchStore]);

  const onPressPushNotify = React.useCallback(() => {
    const { eventName, params } = handlerParamsAppFlyer();
    pushAppFlyer(eventName, params);
    Linking.openURL("tel:+1900555592");
  }, []);

  const onPressDrawer = React.useCallback(() => {
    sideMenu.openMenu();
  }, [sideMenu]);

  const onPressSettings = React.useCallback(() => {
    closeMenu();
    dispatch(StackActions.replace(ScreenNameType.SETTINGS));
  }, [closeMenu, dispatch]);

  const { styles } = useStyles();

  const textPopupStyle = { color: colors.whiteText, ...fonts.medium };

  return (
    <>
      <View style={styles("wrapContainer")}>
        <View style={styles("mobileContainer")}>
          <Appbar.Header style={styles("appbarStyle")}>
            <Appbar.Action onPress={onPressDrawer} icon={"menu"} size={28} />
            <Block middle center flex={1}>
              <Image source={images.logoPVCB_bg_white} style={styles("avatarView")} />
            </Block>
            <Block middle right absRight={10}>
              <Menu visible={visible} onDismiss={closeMenu} anchor={<IconButton onPress={openMenu} icon="dots-vertical" size={24} />}>
                <Menu.Item
                  onPress={onPressPushNotify}
                  title={t("COMMON_HOTLINE_MENU")}
                  titleStyle={styles("commonFont")}
                  icon={({ size }) => <IconsYellowBanking name="hotline" size={size} />}
                />
                <Menu.Item
                  onPress={onPressSettings}
                  title={t("SETTING_CAI_DAT")}
                  titleStyle={styles("commonFont")}
                  icon={({ size }) => <IconsYellowBanking name="caidat" size={size} />}
                />
                <Divider />
                <Menu.Item
                  icon={({ size }) => <IconsYellowBanking name="dangxuat" size={size} />}
                  onPress={onPressLogout}
                  titleStyle={styles("commonFont")}
                  title={t("ACC_DANG_XUAT")}
                />
              </Menu>
            </Block>
          </Appbar.Header>
        </View>

        <View style={styles("desktopContainer")}>
          <Block row center spaced ph={spacing.galactic} minHeight={64}>
            <Block row flex={1} />
            <Block row center flex={1} bottom>
              <QueueSpacing size="medium" />
              <Tippy content={<Text style={textPopupStyle}>{t("COMMON_HOTLINE_MENU")}</Text>}>
                <TouchableOpacity onPress={onPressPushNotify}>
                  <IconsYellowBanking name="hotline" size={28} />
                </TouchableOpacity>
              </Tippy>
              <QueueSpacing size="medium" />
              <Tippy content={<Text style={textPopupStyle}>{t("SETTING_CAI_DAT")}</Text>}>
                <TouchableOpacity onPress={onPressSettings}>
                  <IconsYellowBanking name="caidat" size={24} />
                </TouchableOpacity>
              </Tippy>

              <QueueSpacing size="medium" />
              <Tippy content={<Text style={textPopupStyle}>{t("COMMON_THOAT")}</Text>}>
                <TouchableOpacity onPress={onPressLogout}>
                  <IconsYellowBanking name="dangxuat" size={24} />
                </TouchableOpacity>
              </Tippy>
              <QueueSpacing size="medium" />
            </Block>
          </Block>
        </View>
      </View>
    </>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    wrapContainer: {
      height: 64,
      paddingVertical: 24,
      flexDirection: "row",
      alignItems: "center",
    },
    desktopContainer: {
      display: "flex",
      flexGrow: 1,
    },
    mobileContainer: {
      display: "flex",
      flexGrow: 1,
    },
    avatarView: {
      height: 30,
      width: 64,
    },
    appbarStyle: {
      backgroundColor: "transparent",
      elevation: 0,
    },
    commonFont: {
      fontSize: 13,
    },
    textPopup: {},
  },
  {
    [DEVICE_SIZES.EXTRA_LARGE_DEVICE]: {
      desktopContainer: {
        display: "flex",
      },
      mobileContainer: {
        display: "none",
      },
    },
    [DEVICE_SIZES.LARGE_DEVICE]: {
      desktopContainer: {
        display: "flex",
      },
      mobileContainer: {
        display: "none",
      },
    },
    [DEVICE_SIZES.MEDIUM_DEVICE]: {
      desktopContainer: {
        display: "none",
      },
      mobileContainer: {
        display: "flex",
      },
    },
    [DEVICE_SIZES.SMALL_DEVICE]: {
      desktopContainer: {
        display: "none",
      },
      mobileContainer: {
        display: "flex",
      },
    },
    [DEVICE_SIZES.EXTRA_SMALL_DEVICE]: {
      desktopContainer: {
        display: "none",
      },
      mobileContainer: {
        display: "flex",
      },
    },
  },
);

export default HeaderNav;
